module.exports = __webpack_public_path__ + "img/pfp_me.cff18490.jpg";